var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-interface"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9257 5.99353L9.06373 8.85553L11.9257 11.7175C12.1861 11.9779 12.1861 12.3998 11.9257 12.6603C11.7955 12.7905 11.6249 12.8556 11.4544 12.8556C11.2839 12.8556 11.1133 12.7905 10.9831 12.6603L8.12106 9.79826L5.25906 12.6603C5.12886 12.7905 4.95826 12.8556 4.78773 12.8556C4.61719 12.8556 4.44659 12.7905 4.31639 12.6603C4.05599 12.3999 4.05599 11.978 4.31639 11.7175L7.17839 8.85553L4.31639 5.99353C4.05599 5.73313 4.05599 5.31126 4.31639 5.05079C4.57679 4.79033 4.99866 4.79039 5.25913 5.05079L8.12113 7.91279L10.9831 5.05079C11.2435 4.79039 11.6654 4.79039 11.9259 5.05079C12.1863 5.31119 12.1861 5.73306 11.9257 5.99353Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXInterface);
export default __webpack_public_path__ + "static/media/x-interface.ed75e3f6ed464ad29667eb9fd0aa9535.svg";
export { ForwardRef as ReactComponent };